namespace Portico.Services {

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IPorticoEvents {
        loggedOutEvent(): void;
        unauthorizedEvent(): void;
        addDelegate(eventName: string, func): void;
        removeDelegate(eventName): void;
    }

    export type Delegate = () => void;
          
    @Service('app', 'porticoEvents')
    @Inject('$rootScope')
    export class PorticoEvents implements IPorticoEvents {
        private callbacks: Delegate[];

        constructor(protected $rootScope: ng.IRootScopeService) {
            this.callbacks = [] as Delegate[];
            this.init(this);
        }
        
        // Events that can be fired
        public loggedOutEvent(): void {
            this.$rootScope.$broadcast('loggedOutEvent');
        }

        public unauthorizedEvent(): void {
            this.$rootScope.$broadcast('unauthorizedEvent');
        }

        // Methods for registering and unregistering event callbacks
        public addDelegate(eventName: string, func: Delegate): void {
            if (this.callbacks[eventName] === undefined) {
                throw "the value provided for argument [eventName] is not a valid event.";
            }

            if (typeof func !== 'function') {
                throw "argument [func] does not contain a method";
            }

            this.callbacks[eventName] = this.$rootScope.$on(eventName, () => {
                func();
            });
        }

        public removeDelegate(eventName: symbol): void {
            if (this.callbacks[eventName] === undefined) {
                throw "the value provided for argument [eventName] is not a valid event.";
            }

            this.callbacks[eventName]();
        }

        private init(obj: PorticoEvents): void {
            //debugger;
            const classMembers = Object.getOwnPropertyNames(Object.getPrototypeOf(obj))
                .filter(i => {
                    return i.indexOf('Event') > -1;
                });

            classMembers.forEach(value => {
                if (typeof this[value] === 'function') {
                    this.callbacks[value] = null;
                }
            });
        }
    }
}
